import React from 'react';

import * as s from './PageHeaderLayout.css';

/**
 * Шаблон шапки страницы
 */
export const PageHeaderLayout = ({ children }: { children: React.ReactNode }) => (
  <div className={s['wrapper']}>{children}</div>
);
